import { LearningObjectiveStatementStatus } from '@exam-management/graphql';
import { Flex, Text } from '@shared/components';

import type { LearningObjectiveStatement } from '../../utils';

import LOSStatusIcon from './los-status-icon';

export interface LOSRowSlots {
  endAdornment?: (losData: {
    losId: string;
    status: LearningObjectiveStatementStatus;
  }) => JSX.Element;
  onRowClick?: (losId: string) => void;
}

export interface LOSRowProps {
  los: LearningObjectiveStatement;
  index: number;
  total: number;
  slots?: LOSRowSlots;
}

export default function LOSRow(props: Readonly<LOSRowProps>) {
  const { los, index, total, slots } = props;
  const { id, status, tag } = los;

  const isDisabled = status === LearningObjectiveStatementStatus.Disabled;
  const isClickable = !!slots?.onRowClick && !isDisabled;

  return (
    <Flex
      onClick={isClickable ? () => slots?.onRowClick?.(id) : undefined}
      sx={(theme) => ({
        p: theme.spacing(0, 0, 0, 13),
        width: '100%',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.grey[50],
        borderBottom: index < total - 1 ? `1px solid ${theme.palette.grey[300]}` : 'none',
        minHeight: '52px',
        ...(isClickable && { cursor: 'pointer' }),
      })}
    >
      <Flex
        sx={(theme) => ({
          gap: theme.spacing(3),
        })}
      >
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(3),
            pt: theme.spacing(3.5),
          })}
        >
          <LOSStatusIcon status={status} />
        </Flex>
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(3),
            alignItems: 'center',
            py: theme.spacing(3),
          })}
        >
          <Text
            variant='body1Semibold'
            sx={(theme) =>
              status === LearningObjectiveStatementStatus.Disabled
                ? { color: theme.palette.text.disabled }
                : {}
            }
          >
            {tag.name}
          </Text>
        </Flex>
      </Flex>
      {slots?.endAdornment ? slots.endAdornment({ losId: id, status }) : null}
    </Flex>
  );
}
